import React from "react";
import Accordion from "react-bootstrap/Accordion";
import "../Components/Objectives.css";
import { Link } from "react-router-dom";

const scrollToTop = () => window.scrollTo(0, 0);

/* ─── Services listed in the accordion ───────────────────── */
const SERVICES = [
  {
    key: "0",
    title: "Research Projects",
    slug: "/our-services/research",
    excerpt:
      "CIRCODU does not wait for change; we research it, measure it, and help make it happen. In partnership with local and international organizations, we have spearheaded a diverse portfolio of research projects that advance sustainable development ...",
  },
  {
    key: "1",
    title: "Consultancy",
    slug: "/our-services/consultancy",
    excerpt:
      "CIRCODU's influence extends well beyond research. We bring our analytical depth and sector expertise directly to clients both locally and globally through specialized consultancy services that inform strategy, de-risk decisions, ...",
  },
  {
    key: "2",
    title: "Monitoring and Evaluation",
    slug: "/our-services/monitoring-and-evaluation",
    excerpt:
      "Since its very inception, CIRCODU has been at the forefront of environmental monitoring and the promotion of cleaner, smarter technologies. We believe that meaningful change can only be sustained when it is rigorously tracked, and that's exactly what we do. ...",
  },
  {
    key: "3",
    title: "Cookstoves and Fuel Testing",
    slug: "/our-services/cookstoves-and-fuel-testing",
    excerpt:
      "Established in 2010, the CIRCODU Cookstoves and Fuel Testing Laboratory has grown from a national asset into a Regional Knowledge and Testing Centre recognized and actively supported by the Clean Cooking Alliance. It stands today as one ...",
  },
  {
    key: "4",
    title: "Capacity Building",
    slug: "/our-services/capacity-building",
    excerpt:
      "At CIRCODU, we understand that sustainable change doesn't just come from research and policy; it comes from people. That's why we have expanded our work to include community-based training programs that put knowledge, skills, and ...",
  },
];

function Objectives() {
  return (
    <div className="container objectiv">
      <div className="row">
        {/* Who We Are */}
        <div className="col-md-6">
          <div className="row extend">
            <div className="col-md-12 mb-4 text-center main-heading-para">
              <h2
                className="main-heading-obj py-2"
                style={{ color: "#008250" }}
              >
                Who We Are
              </h2>
              <div className="underline-card mx-auto" />
              <p className="texthome1">
                Founded in 2007, the Centre for Integrated Research and
                Community Development Uganda (CIRCODU) is a non-profit
                organization driven by a single, powerful conviction that
                rigorous research and smart consultancy can change lives. From
                the villages of Uganda to communities across Kenya, Tanzania,
                Gambia, Mali, Sudan, and beyond, we show up where it matters
                most, armed with data, expertise, and an unwavering commitment
                to a better world.
              </p>
              <p className="texthome1">
                We are researchers, analysts, and community champions. Our work
                sits at the intersection of science and society tackling the
                challenges that affect people's health, environment, and
                livelihoods every day. We don't just study problems. We help
                solve them. Whether it's testing cookstoves for safety and
                efficiency, ...
              </p>
              <Link
                to="/about-us/who-we-are"
                className="read-more-btn mb-1"
                onClick={scrollToTop}
                aria-label="Read more about who we are at CIRCODU"
              >
                Read More
              </Link>
            </div>
          </div>
        </div>

        {/* What We Do */}
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-12 mb-4 text-center main-heading-obj">
              <h2
                className="main-heading-obj py-2"
                style={{ color: "#008250" }}
              >
                What We Do
              </h2>
              <div className="underline-card mx-auto" />
            </div>
          </div>

          <Accordion style={{ color: "#008250" }}>
            {SERVICES.map((service) => (
              <Accordion.Item key={service.key} eventKey={service.key}>
                <Accordion.Header>
                  <b style={{ color: "#008250", fontSize: "14px" }}>
                    {service.title}
                  </b>
                </Accordion.Header>
                <Accordion.Body style={{ color: "#000000" }}>
                  <p className="texthome">{service.excerpt}</p>
                  <Link
                    to={service.slug}
                    className="read-more-btn"
                    onClick={scrollToTop}
                    aria-label={`Read more about ${service.title}`}
                  >
                    Read More
                  </Link>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
}

export default Objectives;
